import { TmdxRadioGroup } from '@ds';
import { CaseCardType } from '@lp/features/CasesBoard/components/CaseCard/constants';
import { BaseCaseCard } from '@lp/features/CasesBoard/components/CaseCard/components/Cards';
import { SelectCasesType } from '@lp/features/MultiSuggest/types';
import { useCandidatesList } from '@lp/features/MultiSuggest/hooks';
import { InfoBanner } from '@ui';
import { Case } from '@/api/apis/case';
import { CaseListWrapper } from './CaseListWrapper';
import { ListEmptyState } from '../ListEmptyState';

type InitialCasesListProps = {
  cases: Case[];
  selectedCase: Case | null;
  isVisible: boolean;
  invalidUnosId: string | null;
  onCaseSelect: (caseItem: Case) => void;
};

export const InitialCasesList = ({
  cases,
  selectedCase,
  invalidUnosId,
  isVisible,
  onCaseSelect,
}: InitialCasesListProps) => {
  const { filteredList, activeIds, searchText, onSearch } = useCandidatesList(cases);

  return (
    <CaseListWrapper
      modalContentType={SelectCasesType.Initial}
      searchText={searchText}
      isVisible={isVisible}
      casesCount={cases.length}
      onSearchChange={onSearch}
    >
      {!!invalidUnosId && (
        <InfoBanner key="invalid-initial-case" iconType="warning">
          {`The case ${invalidUnosId} was checked against the initial case criteria. Only eligible cases appear in the list below. Please select a case to continue.`}
        </InfoBanner>
      )}
      {filteredList.length ? (
        <TmdxRadioGroup
          as="div"
          value={selectedCase?.caseId || ''}
          orientation="horizontal"
          className="flex gap-4 flex-wrap"
        >
          {filteredList.map((c) => (
            <BaseCaseCard
              key={c.caseId}
              cardType={CaseCardType.Candidate}
              caseData={c}
              selectType="single"
              isSelected={c.caseId === selectedCase?.caseId}
              isDisabled={!activeIds.has(c.caseId)}
              onClick={() => onCaseSelect(c)}
            />
          ))}
        </TmdxRadioGroup>
      ) : (
        <ListEmptyState
          iconSize="lg"
          message="Looks like no cases are matching the initial case criteria at the moment. Please try again later."
        />
      )}
    </CaseListWrapper>
  );
};
